module.exports = __webpack_public_path__ + "9f3ecfae955872804de8fa35460b5c41.png";